<script>
const { VUE_APP_API_HOST } = process.env

export default {
  methods: {
    getTemplates(type) {
      return this.$http.get(`${VUE_APP_API_HOST}/templates`, {
        params: { type },
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      })
      .then(
        (res) => res.body.templates || [],
        (err) => err
      )
    },

    newTemplate(template) {
      return this.$http
        .post(`${VUE_APP_API_HOST}/templates/`, template, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        })
        .then(
          (res) => res,
          (err) => err
        )
    },

    updateTemplate(template) {
      return this.$http
        .put(`${VUE_APP_API_HOST}/templates/${template.id}`, template, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        })
        .then(
          (res) => res,
          (err) => err
        )
    },

    deleteTemplate(id) {
      return this.$http
        .delete(`${VUE_APP_API_HOST}/templates/${id}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        })
        .then(
          (res) => res,
          (err) => err
        )
    },

    reorderTemplates({ folderId, orderedIds }) {
      return this.$http
        .post(`${VUE_APP_API_HOST}/templates/position`, { folderId, orderedIds }, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        })
        .then(
          (res) => res,
          (err) => err
        )
    }
  }
}
</script>
